import { useEffect, useState, useCallback } from 'react';
import { logError } from '../../lib/logger';
import { Sparkles, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminHiddenStories = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [featuringId, setFeaturingId] = useState(null);
  const [featuredIds, setFeaturedIds] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/admin/stories/hidden?limit=30`, { credentials: 'include' });
      if (res.ok) setStories(await res.json());
    } catch (e) {
      logError('AdminHiddenStories:load', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleFeature = async (storyId) => {
    setFeaturingId(storyId);
    try {
      const res = await fetch(`${BACKEND_URL}/api/admin/stories/${storyId}/feature`, {
        method: 'POST',
        credentials: 'include',
      });
      if (res.ok) setFeaturedIds((prev) => [...prev, storyId]);
    } catch (e) {
      logError('AdminHiddenStories:feature', e);
    } finally {
      setFeaturingId(null);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-10" data-testid="admin-hidden-loading">
        <Loader2 className="w-6 h-6 animate-spin text-gray-400" />
      </div>
    );
  }

  return (
    <div data-testid="admin-hidden-list">
      {stories.length === 0 && (
        <p className="text-sm text-gray-500" data-testid="admin-hidden-empty">No hidden stories right now.</p>
      )}
      <div className="divide-y divide-gray-100">
        {stories.map((story) => {
          const isFeatured = featuredIds.includes(story.id);
          return (
            <div key={story.id} className="flex items-center justify-between gap-4 py-3" data-testid={`admin-hidden-row-${story.id}`}>
              <div className="min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">{story.primary_headline}</p>
                <p className="text-xs text-gray-500">{story.article_count} source{story.article_count === 1 ? '' : 's'}</p>
              </div>
              <button
                onClick={() => handleFeature(story.id)}
                disabled={featuringId === story.id || isFeatured}
                data-testid={`admin-feature-btn-${story.id}`}
                className={`shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border transition-colors ${
                  isFeatured
                    ? 'border-emerald-200 bg-emerald-50 text-emerald-700 cursor-default'
                    : 'border-amber-300 text-amber-700 hover:bg-amber-50'
                }`}
              >
                <Sparkles className="w-3.5 h-3.5" />
                {isFeatured ? 'Featured' : featuringId === story.id ? 'Featuring...' : 'Feature on homepage'}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
